import { render, staticRenderFns } from "./CategorySteps.vue?vue&type=template&id=609c3af1&scoped=true&"
import script from "./CategorySteps.vue?vue&type=script&lang=js&"
export * from "./CategorySteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609c3af1",
  null
  
)

export default component.exports